export default function (link) {
    link && window && (window.location.href = link);
}


// WEBPACK FOOTER //
// ./src/util/redirect.js